import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { AutocompleteRenderInputParams, Box, FormInputText, InputLabel, Select } from '@hopskipdrive/react-components';

import { useDeactivateReason } from './useDeactivateReason';
import { deactivateRiderValidationSchema } from './vailidationSchema';

interface DeactivateRiderFormProps {
  handleDeactivateRider: (data: DeactivateRiderFormType) => void;
}

interface DeactivateRiderFormType {
  reasonKey: string;
}

export const DeactivateRiderForm = ({ handleDeactivateRider }: DeactivateRiderFormProps) => {
  const { deactivateReasons } = useDeactivateReason();
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<DeactivateRiderFormType>({
    defaultValues: {},
    resolver: yupResolver(deactivateRiderValidationSchema),
  });

  return (
    <form id="deactivate-rider-form" onSubmit={handleSubmit(handleDeactivateRider)}>
      <Box display="flex" flexDirection="column" mt=".75rem" gap="3px">
        <InputLabel htmlFor="reasonKey" fieldtype="required" style={{ fontWeight: 300 }}>
          Reason
        </InputLabel>
        <Controller
          control={control}
          name="reasonKey"
          render={({ field: { onChange, value } }) => (
            <Select
              options={deactivateReasons}
              value={value}
              setValue={onChange}
              renderInput={(params: AutocompleteRenderInputParams) => (
                <FormInputText
                  {...params}
                  variant="outlined"
                  placeholder="Select a reason"
                  fullWidth
                  error={!!errors.reasonKey}
                  helperText={errors.reasonKey?.message}
                />
              )}
            />
          )}
        />
      </Box>
    </form>
  );
};
